import React, { useEffect, useState } from "react";
import Layout from "../../layouts/Layout";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import CreatorInfo from "../../Components/Creators/CreatorInfo";
import AnalyticsComponent from "../../Components/Profile/AnalyticsComponent";
import TopVideos from "../../Components/Creators/TopVideos";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../utils/config/config";
import CreatorContentGallery from "../../Components/Creators/CreatorContentGallery";
import {
  followCreator,
  getAllCreators,
  getCreatorsSubscribed,
  getUserById,
  unFollowCreator,
  unSubscribeCreator,
  profileVisit,
} from "../../redux/actions/user.dispatcher";
import {
  Box,
  Grid2,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CustomTabs from "../../Components/Common/CustomTabs";
import AddEventDrawer from "../../Components/ExerciseCalendar/AddEventDrawer";
import ScheduleEvent from "../../Components/ExerciseCalendar/ScheduleEvent";
import { useDispatch, useSelector } from "react-redux";
import { CustomBtn, SecondaryBtn } from "../../Components/Common/CustomBtn";
import { colors } from "../../theme/theme";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../Components/Common/CustomSnackbar";
import { Add, PlusOneOutlined } from "@mui/icons-material";
import {
  getUserPaidVideos,
  getUserSavedVideos,
} from "../../redux/actions/posts.dispatcher";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [type, setType] = useState("my_videos");
  const [userPosts, setuserPosts] = useState(null);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [success, setSuccess] = useState(false);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [tabs, setTabs] = useState("my_videos");
  const handleChange = (event, newValue) => {
    setTabs(newValue);
  };

  const [calendarComponentState, setCalenderComponentState] = useState(false);
  const { userData } = useSelector((state) => state.user);
  const { userPaidVideos } = useSelector((state) => state.posts);
  const { userSavedVideos } = useSelector((state) => state.posts);
  const [userInfo, setUserInfo] = useState(null);
  const [analytics, setAnalytics] = useState(null);

  const fetchAnalytics = async () => {
    try {
      const resp = await axiosInstance.get(`user/analytics/${userData.id}`);

      setAnalytics(resp.data);
    } catch (err) {
      console.log(err);
    }
  };

  const tabsData = [
    {
      id: 1,
      label: "My Videos",
      value: "my_videos",
    },
    {
      id: 2,
      label: "Paid Videos",
      value: "videos",
    },
    {
      id: 2,
      label: "Saved Videos",
      value: "saved",
    },
  ];

  // const fetchAllCreators = async () => {
  //   try {
  //     const creatorReesponse = await axiosInstance.get("/user/getAllCreators");
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const fetchUserPaidVideos = async () => {
  //   try {
  //     const { data } = await axiosInstance.get(`/post/userPaidVideos`);

  //     console.log("Daat", data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const fetchUserPosts = async () => {
    try {
      const posts = await axiosInstance.get(
        `/post/userPosts?userId=${userData?.id}`
      );
      setuserPosts(posts.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getRecentProfileViewsCount = () => {
    if (!userData?.profileViewsReceived) return 0;

    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    return userData.profileViewsReceived.filter((view) => {
      return new Date(view.createdAt) >= thirtyDaysAgo;
    }).length;
  };

  useEffect(() => {
    dispatch(getUserById(id));
    fetchUserPosts();
    fetchAnalytics();
    dispatch(getUserPaidVideos());
    dispatch(getUserSavedVideos());
  }, [id]);
  return (
    <Layout>
      {/* <HeadingWithBtns analytics /> */}
      <CreatorInfo userData={userData} />
      {userData?.creatorId && (
        <AnalyticsComponent
          setCalenderComponentState={setCalenderComponentState}
          isSelf
          data={analytics}
        />
      )}
      <ErrorSnackbar
        error={errorState.error}
        errorMsg={errorState.message}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={"Profile URL Copied to clipboard!."}
      />
      {userData?.creatorId && (
        <Stack direction={"row"}>
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
              mt: 4,
              padding: "5px 10px",
              display: "flex",
              gap: "5px",
              alignItems: "flex-start",
              background: "#D4D5D7",
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() => {
              if (
                userData.subscriptionPlan == "Basic Plan" ||
                !userData.subscriptionPlan
              ) {
                setErrorState({
                  error: true,
                  message:
                    "Upgrade to Growth to access professional dashboard.",
                });
              } else {
                navigate(`/creator/${userData.id}/content-analytics`);
              }
            }}
          >
            <Typography
              sx={{
                fontSize: smallScreen ? "16px" : "20px",
                fontFamily: "Inter-Bold",
                color: colors.textColor,
              }}
            >
              Professional Dashboard
            </Typography>
            <Typography
              sx={{
                fontSize: smallScreen ? "12px" : "20px",
                fontFamily: "Inter-Bold",
                color: "#8C8D8F",
              }}
            >
              {getRecentProfileViewsCount().toLocaleString()} views in the last
              30 days.
            </Typography>
          </Box>
        </Stack>
      )}

      <Stack direction={"row"} gap={"10px"}>
        <SecondaryBtn
          text={"Edit Profile"}
          noIcon
          width={"50%"}
          noMb
          onClick={() => navigate("/edit-profile")}
        />
        <SecondaryBtn
          text={"Share Profile"}
          noIcon
          width={"50%"}
          noMb
          onClick={() => {
            try {
              const url = `https://app.only-hands.net/profile/${userData.id}`;
              navigator.clipboard.writeText(url);
              setSuccess(true);
            } catch (err) {
              setErrorState({
                error: true,
                message: "Error copying URL.",
              });
            }
          }}
        />
      </Stack>
      {/* <TopVideos /> */}
      <ScheduleEvent
        drawerState={calendarComponentState}
        setDrawerState={setCalenderComponentState}
        creatorId={userData?.id}
        type="video"
      />

      {!smallScreen && userData.creatorId && (
        <SecondaryBtn
          text={"Create Post"}
          Icon={Add}
          width={"100%"}
          noMb
          onClick={() => navigate("/creator/upload-content")}
        />
      )}
      {smallScreen ? (
        <>
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
              mt: 4,
            }}
          >
            <Tabs
              value={tabs}
              onChange={handleChange}
              textColor="inherit"
              indicatorColor="#FC0108"
              aria-label="secondary tabs example"
              sx={{
                width: "100%", // Prevents overflow
                display: "flex",
                justifyContent: "center",
                "& .MuiTab-root": {
                  fontSize: "12px",
                  flex: 1, // Makes tabs equal width
                  maxWidth: "50%", // Restricts each tab to 50% width
                  borderBottom: "2px solid #000", // Black border for unselected tabs
                  opacity: 1,
                },
                "& .Mui-selected": {
                  color: "#FC0108", // Selected tab text color
                  borderBottom: "2px solid #FC0108 !important", // Red border for selected tab
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#FC0108", // Red indicator color
                },
              }}
            >
              <Tab
                sx={{
                  px: 1,
                }}
                value="my_videos"
                label="My Videos"
              />
              <Tab
                sx={{
                  px: 1,
                }}
                label="Paid Videos"
                value="videos"
              />
              <Tab
                sx={{
                  px: 1,
                }}
                label="Saved Videos"
                value="saved"
              />
            </Tabs>
          </Box>
          <Box
            sx={{
              mt: 4,
              pb: 12,
            }}
          >
            {tabs === "my_videos" ? (
              <CreatorContentGallery
                title="My Videos"
                type="videos"
                allData={userPosts || []}
                fetchUserPosts={fetchUserPosts}
              />
            ) : tabs === "videos" ? (
              <CreatorContentGallery
                title="Paid Videos"
                type="videos"
                allData={userPaidVideos || []}
              />
            ) : tabs === "saved" ? (
              <CreatorContentGallery
                title="Saved Videos"
                type="videos"
                allData={userSavedVideos || []}
              />
            ) : (
              // <CreatorContentGallery title="Subscribed Users" type="creators" />
              <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Box
                  sx={{
                    width: "100%",
                    height: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <img
                    src={require("../../assets/icons/no-results.png")}
                    style={{
                      height: "50px",
                      width: "50px",
                    }}
                    alt="no-content"
                  />
                  <Typography
                    sx={{
                      fontFamily: "Inter-SemiBold",
                      fontSize: "24px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    You dont have any playlists yet.
                  </Typography>
                </Box>
              </Grid2>
            )}
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              mt: 4,
            }}
          >
            <CustomTabs
              data={tabsData}
              value={type}
              setValue={setType}
              fullScreen
            />
          </Box>
          <Box
            sx={{
              mt: 4,
            }}
          >
            {type === "my_videos" ? (
              <CreatorContentGallery
                title="My Videos"
                type="videos"
                allData={userPosts || []}
              />
            ) : type === "videos" ? (
              <CreatorContentGallery
                title="Paid Videos"
                type="videos"
                allData={userPaidVideos || []}
              />
            ) : type === "saved" ? (
              <CreatorContentGallery
                title="Saved Videos"
                type="videos"
                allData={userSavedVideos || []}
              />
            ) : (
              // <p>Hello</p>
              // <CreatorContentGallery title="Subscribed Users" type="creators" />
              <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Box
                  sx={{
                    width: "100%",
                    height: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <img
                    src={require("../../assets/icons/no-results.png")}
                    style={{
                      height: "50px",
                      width: "50px",
                    }}
                    alt="no-content"
                  />
                  <Typography
                    sx={{
                      fontFamily: "Inter-SemiBold",
                      fontSize: "24px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    You dont have any playlists yet.
                  </Typography>
                </Box>
              </Grid2>
            )}
          </Box>
        </>
      )}
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
    </Layout>
  );
};

export default Profile;
